import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { SplashScreen } from './SplashScreen';

export function ProtectedRoute() {
  const { user, loading } = useAuth();
  if (loading) return <SplashScreen label="Вход…" />;
  if (!user) return <Navigate to="/login" replace />;
  return <Outlet />;
}
